import React from "react";
import Image from "../assets/LUXURY.png";
import Image2 from "../assets/TEEM.png";
import Image3 from "../assets/PLOT BAZAR.png";
// import logo11 from '../assets/logo 11.png';
import logo2 from '../assets/logo 2.png';
import logo3 from '../assets/logo 3.png';
import logo1 from '../assets/logo 1.png';
import AOS from "aos";
import Image4 from "../assets/sweden.png";
import Image5 from "../assets/The Amrita Hills.png";
import Image6 from "../assets/SUGARDREAM.png";
import { FaStar, FaStarHalf } from "react-icons/fa";
import google from '../assets/google.jpg';
import { Link } from "react-router";

const Testimonial = () => {
  React.useEffect(() => {
    AOS.init();
  }, []);

  const openLink = (url) => {
    window.open(url, '_blank');
  };

  return (
    <div id="work" className="flex justify-center items-center md:px-20 px-4 py-24">
      <div className="flex flex-col justify-center items-center">
        <div className="p-4 md:w-full w-full flex flex-col justify-center items-center text-center">
          <p className="font-bold text-2xl text-orange-800">
            Discover why Clients Trust The Krisoft Corporation.
          </p>
          <p className="mt-4 text-gray-700">
            We don't just make websites pretty, we make them profitable.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mt-10">
          {[Image3, Image2, Image, Image6, logo3, Image4, Image5, logo2, logo1].map((img, index) => (
            <div key={index} className="p-2 cursor-pointer" onClick={() => openLink('#')}>
              <img className="h-36 md:h-40 hover:bg-gray-200 rounded-md shadow" src={img} alt="Client Logo" />
            </div>
          ))}
        </div>

        {/* Client Testimonial */}
        <div className="p-8 bg-[#FAEBCC] mt-12 w-full text-center">
          <h1 className="text-4xl font-bold text-blue-950">
            Let our clients <span className="font-dancing text-5xl text-red-900">Speak for us</span>
          </h1>

          <h1 className="text-2xl font-bold text-blue-950 mt-6">
            <Link to="https://www.google.com/maps/place/thekrisoft+corporation/" target="_blank">Rating</Link>
          </h1>
          <div className="flex justify-center mt-2">
            {[...Array(4)].map((_, i) => <FaStar key={i} className="text-yellow-500 text-2xl" />)}
            <FaStarHalf className="text-yellow-500 text-2xl" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-10">
            {[{
              link: "https://g.co/kgs/Uh2ztN1",
              name: "Rahul Mishra",
              review: "The Krisoft Corporation’s team is the name of professionalism and client-oriented attitude."
            }, {
              link: "https://g.co/kgs/xbjEvt1",
              name: "Laxmipati",
              review: "You guys are simply outstanding 👏"
            }, {
              link: "https://g.co/kgs/PBt9VyA",
              name: "Pankaj Khatreja",
              review: "Delighted by the timely services provided as expected.."
            }].map((testimonial, i) => (
              <a key={i} href={testimonial.link} target="_blank" rel="noopener noreferrer" className="p-4 border rounded shadow bg-white block">
                <div className="flex justify-center">
                  <img src={google} alt="google" className="mt-4 w-5" />
                </div>
                <div className="flex justify-center mt-2">
                  {[...Array(5)].map((_, j) => <FaStar key={j} className="text-yellow-500 text-2xl" />)}
                </div>
                <h6 className="mt-4 text-gray-700">{testimonial.review}</h6>
                <p className="mt-2 font-semibold">{testimonial.name}</p>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
